import { z } from 'zod';
import { PROVIDER_STATUSES, Province, Role } from './enums.js';
import { Cuid2, Email, MemberNumber, PersonName } from './primitives.js';
/**
 * `GET /me` on the API. The signed-in user plus the basics of their profile,
 * which the role shells use to decide what to show. Null profile parts are
 * normal: admins have no profile, and a member profile can still be missing
 * in the window between sign-up and the profile write.
 */
export const MeDto = z.object({
    user: z.object({
        id: Cuid2,
        name: z.string(),
        email: Email,
        emailVerified: z.boolean(),
        role: Role,
    }),
    member: z
        .object({
        memberNumber: MemberNumber,
        firstName: PersonName,
        /** The primary address's province (D25). Null only if the address is missing. */
        province: Province.nullable(),
    })
        .nullable(),
    provider: z
        .object({
        id: Cuid2,
        status: z.enum(PROVIDER_STATUSES),
        contactFirstName: z.string(),
        /** The trading name, or the legal name if there is none. */
        displayName: z.string(),
    })
        .nullable(),
});
//# sourceMappingURL=me.js.map